export {UdalostiProps} from "./udalosti.props";
export {CalendarProps} from "./calendar.props";
export const udalosti_name = "UdalostiComponent";
export const name_calendar = "CalendarComponent";
